export interface AppStoreDataModel {
  whatsapp: any | null;
  cartReminder: any | null;
}
